<template>
  <div class="pagination">
    <div class="pagination-text" v-if="itemTo">
      Showing {{ itemFrom }} to {{ itemTo }} of {{ totalItems }} results
    </div>
    <div>
      <button
        class="prev"
        @click="prev"
        :class="{ 'page-disabled': firstDisabled }"
        v-bind:disabled="firstDisabled"
      >
        <i class="admin-arrow admin-left"></i>
      </button>
      <span v-for="(item, i) in links" :key="i">
        <button
          v-if="item"
          style="margin: 0px 3px"
          :class="{
            'page-active': item == lastCurrentPage,
          }"
          @click="move(item)"
        >
          <span>
            {{ item }}
          </span>
        </button>
        <!-- <button
          disabled
          v-if="i == 1 && links.length > 5"
          style="margin-right: 3px"
        >
          ...
        </button> -->
      </span>
      <button
        class="next"
        @click="next"
        :class="{ 'page-disabled': lastDisabled }"
        v-bind:disabled="lastDisabled"
      >
        <i class="admin-arrow admin-right"></i>
      </button>
    </div>
    <!-- <div class="pagination-paginate">
      <select @change="$emit('mutatePerPage', $event.target.value)">
        <option :value="10" selected>10</option>
        <option :value="20">20</option>
        <option :value="30">30</option>
        <option :value="40">40</option>
        <option :value="50">50</option>
      </select>
    </div> -->
  </div>
</template>


<script>
export default {
  props: {
    totalPage: {
      type: Number,
    },
    lastPage: {
      type: Number,
    },
    totalItems: {
      type: Number,
    },
    itemFrom: {
      type: Number,
    },
    itemTo: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
    // links: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    perPage: {
      type: Number,
    },
  },
  data() {
    return {
      options: [
        { label: "10", value: 10 },
        { label: "20", value: 20 },
        { label: "30", value: 30 },
        { label: "40", value: 40 },
        { label: "50", value: 50 },
      ],
      lastCurrentPage: this.currentPage,
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    prev() {
      this.$emit("mutateCurrentPage", this.currentPage - 1);
    },
    next() {
      this.$emit("mutateCurrentPage", this.currentPage + 1);
    },
    move(item) {
      if (item != this.currentPage) {
        this.$emit("mutateCurrentPage", item);
      }
    },
  },
  computed: {
    firstDisabled() {
      return this.currentPage == 1;
    },
    lastDisabled() {
      return this.currentPage == this.totalPage;
    },
    firstPage() {
      return 1;
    },
    links() {
      let links = [];
      let link = [];
      let current5 = 5;

      for (let i = 0; i < this.totalPage; i++) {
        if (!(i < current5)) {
          current5 = current5 + 5;
          link = [];
        }

        link.push(i + 1);

        if (i % 5 == 0) {
          links.push(link);
        }
      }

      const linksIndex = parseInt(this.lastCurrentPage / 6);

      return links[linksIndex];
    },
  },
  watch: {
    currentPage(value, oldValue) {
      if (value) this.lastCurrentPage = value;
      else {
        this.lastCurrentPage = oldValue;
      }
    },
  },
};
</script>


<style lang="css" scoped>
.page-active {
  /* border-color: #5d4580; */
  background-color: rgba(39, 174, 96, 1);
  color: white;
}

.page-disabled {
  /* background-color: #8e8f93; */
  color: white;
  border: none;
}

button {
  background-color: white;
  /* border: solid 1px #dfe3e8; */
  border: none;
  border-radius: 5px;
  color: black;
  width: 32px;
  height: 32px;
}

button:focus {
  outline: none;
}

.pagination {
  margin-top: 39px;
  margin-bottom: 38px;
  display: flex;
  justify-content: flex-end;
  position: relative;
  border-bottom: 1px solid rgba(234, 237, 240, 1);
  height: 50px;
}

select {
  border: none;
}

.pagination-text {
  position: absolute;
  left: 0;
}

.pagination-paginate {
  position: absolute;
  right: 20px;
}
</style>
